import React from 'react';
import MainLayout from 'src/components/MainLayout/MainLayout';

const MyProfilePage = (): JSX.Element => {
  return (
    <MainLayout isPrivate isPrivateInnerFull>
      <h2>MyProfile</h2>
    </MainLayout>
  );
};

export default MyProfilePage;
